import { Box } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { fetchSealineAndFacilityData } from '../../services/entityInstanceServices'
import { AttributeType } from '../../constants/constants'
import SearchInAPIAndSelectInput from './SearchInAPIAndSelectInput'

interface SealineAttributeProps {
    label: string
    id: string
    value: any
    onChange: any
    type: string
    errorMessage?: string
    required?: boolean
    disabled?: boolean
}

const SealineAttribute = (props: SealineAttributeProps): ReactElement => {
    const {
        label,
        id,
        value,
        onChange,
        type,
        errorMessage,
        required,
        disabled,
    } = props

    const [list, setList] = useState<any[]>([])

    const [selectedValue, setSelectedValue] = useState<any>([])

    const [searchText, setSearchText] = useState<string>('')

    const [pageNumber, setPageNumber] = useState<number>(1)

    const [hasMore, setHasmore] = useState<boolean>(false)

    const [isFetching, setIsFetching] = useState(false)

    useEffect(() => {
        setSelectedValue(value)
    }, [value])

    const getId = (item: any) => {
        if (type.toLowerCase() === AttributeType.SEALINE) {
            return item.scac
        } else if (type.toLowerCase() === AttributeType.FACILITY) {
            return item.id
        } else {
            return item.id
        }
    }
    const getName = (item: any) => {
        if (type.toLowerCase() === AttributeType.SEALINE) {
            return item.name
        } else if (type.toLowerCase() === AttributeType.FACILITY) {
            return item.locationName
        } else {
            return item.name
        }
    }

    useEffect(() => {
        const getLatestList = async () => {
            setIsFetching(true)

            const queryParams = {
                pageNumber,
                pageSize: 30,
                searchText,
                dataType: type,
            }
            try {
                const records = await fetchSealineAndFacilityData(queryParams)
                const updatedRecords =
                    records?.data?.map((i: any) => ({
                        ...i,
                        id: getId(i),
                        name: getName(i),
                    })) || []
                setList((prev) =>
                    pageNumber === 1
                        ? updatedRecords
                        : [...prev, ...updatedRecords],
                )
                setHasmore(updatedRecords.length === 30)
            } finally {
                setIsFetching(false)
            }
        }

        getLatestList()
    }, [pageNumber, searchText, type])

    const onSelectRecord = (id: string, item: any) => {
        setSelectedValue(item)
        onChange(id, item)
    }
    const onSearch = (id: string, text: any) => {
        setSearchText(text)
        setPageNumber(1)
    }

    const handleFetchNextPage = () => {
        if (!isFetching && hasMore) {
            setPageNumber((prev) => prev + 1)
        }
    }

    return (
        <Box>
            <SearchInAPIAndSelectInput
                key={id}
                label={label}
                id={id}
                value={selectedValue}
                list={list}
                required={required}
                disabled={disabled}
                onSelect={onSelectRecord}
                onSearch={onSearch}
                errorMessage={errorMessage}
                onFetchNextPage={handleFetchNextPage}
                hasMore={hasMore}
                isFetching={isFetching}
            />
        </Box>
    )
}

export default SealineAttribute
